import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(['container', 'label', 'input']);

const getContainerType = (hasSelectedFiles?: boolean) => {
  if (hasSelectedFiles) {
    return {
      alignItems: 'center',
      backgroundColor: 'neutral.100',
      border: '1px solid',
      borderColor: 'neutral.90',
      borderRadius: '8',
      display: 'flex',
      justifyContent: 'space-between',
      paddingX: '24',
      paddingY: '16',
    };
  }
  return {
    _active: {
      backgroundColor: 'purple.93',
    },
    _disabled: {
      _active: {
        backgroundColor: 'neutral.95',
      },
      _hover: {
        backgroundColor: 'neutral.95',
      },
    },
    _hover: {
      backgroundColor: 'purple.93',
    },
    backgroundColor: 'neutral.95',
    borderRadius: '8',
    cursor: 'pointer',
    padding: '8',
  };
};

const FileInputTheme = defineMultiStyleConfig({
  baseStyle: ({ hasSelectedFiles }) => ({
    container: getContainerType(hasSelectedFiles),
    input: {
      display: 'none',
    },
    label: {
      _active: {
        borderColor: 'purple.10',
        color: 'purple.10',
      },
      _disabled: {
        borderColor: 'neutral.60',
        color: 'neutral.60',
        cursor: 'not-allowed',
      },
      _invalid: {
        borderColor: 'red.50',
        color: 'red.50',
      },
      alignItems: 'center',
      border: '1px dashed',
      borderColor: 'purple.50',
      borderRadius: '4',
      color: 'purple.50',
      cursor: 'pointer',
      display: 'flex',
      gap: '8',
      justifyContent: 'center',
      padding: '24',
    },
  }),
});

export default FileInputTheme;
